import React from "react";
import { Button, List, Switch, Tag, Typography } from "antd";

const SavedCardsList = ({
  savedCards,
  onEdit,
  onStatusChange,
  isLoading,
  title,
}) => {
  return (
    <div style={{ marginTop: "30px" }}>
      <Typography.Title level={5}>
        {title} Prime Discount Deals
      </Typography.Title>

      <List
        itemLayout="horizontal"
        dataSource={savedCards}
        loading={isLoading}
        renderItem={(card, index) => (
          <List.Item
            actions={[
              <Button key="edit" onClick={() => onEdit(card)}>
                Edit
              </Button>,
              <Switch
                onChange={(event) => onStatusChange(card, event)}
                checkedChildren="Visible"
                unCheckedChildren="Hidden"
                checked={card?.isActive}
              />,
            ]}
          >
            <List.Item.Meta
              title={<div>{card.heading}</div>}
              description={
                <div>
                  {card.description}
                  {card.position && (
                    <Tag
                      color={card.position === "first" ? "purple" : "green"}
                      style={{ marginLeft: "10px" }}
                    >
                      {card.position === "first"
                        ? "First Slider"
                        : "Second Slider"}
                    </Tag>
                  )}
                </div>
              }
              avatar={
                card.imageUrl ? (
                  <img
                    src={card.imageUrl}
                    alt="Card"
                    style={{ width: "100px", borderRadius: "5px" }}
                  />
                ) : (
                  <div>No Image</div>
                )
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
};

export default SavedCardsList;
